import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { userSelector } from "../../slices/userSlice";
import { UserName } from "components/common/UserName";
import { Nav } from "reactstrap";
var ps;
let userSlice;
function Sidebar(props) {

  const location = useLocation();
  const sidebar = React.useRef();
  const activeRoute = (routeName) => {
    const pathSegments = location.pathname.split('/').filter(segment => segment);
    return "/" + pathSegments[pathSegments.length - 1] === routeName ? 'active' : "";
  };
  const mainRoutes = props.routes.slice(0, 2);
  const securityRoutes = props.routes.slice(2);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const clientRef = React.useRef(null);
  const permissionRef = React.useRef(null);
  const toolsRef = React.useRef(null);
  const settingsRef = React.useRef(null);

  const handleNavLinkClick = () => {
    if (window.innerWidth <= 991) {
      props.toggleSidebar();
    }
  };

  useEffect(() => {
    userSlice = require("../../slices/userSlice")
  }, [])

  const handleLogout = () => {
    navigate('/login', { replace: true });
    dispatch(userSlice.logout());
  };


  useEffect(() => {
    if (location.pathname.includes("clients")) {
      clientRef.current?.ariaExpanded == "false" && clientRef.current.click()
    }
    else {
      clientRef.current?.ariaExpanded == "true" && clientRef.current.click()
    }

    if (location.pathname.includes("permissions")) {
      permissionRef.current?.ariaExpanded == "false" && permissionRef.current.click()
    }
    else {
      permissionRef.current?.ariaExpanded == "true" && permissionRef.current.click()
    }

    if (location.pathname.includes("tools")) {
      toolsRef.current?.ariaExpanded == "false" && toolsRef.current.click()
    }
    else {
      toolsRef.current?.ariaExpanded == "true" && toolsRef.current.click()
    }

    if (location.pathname.includes("settings")) {
      settingsRef.current?.ariaExpanded == "false" && settingsRef.current.click()
    }
    else {
      settingsRef.current?.ariaExpanded == "true" && settingsRef.current.click()
    }
  }, [location.pathname])

  function IncludesUrl(baseUrl) {
    return props.routes.map(i => i?.path).includes(baseUrl)
  }
  const ClientCollapse = ['clients/templates', 'clients/accounts'];
  const ToolsCollapse = ['tools/facility', 'tools/department'];
  const SettingsCollapse = ['settings/languages', 'settings/language-tiers', 'settings/state', "settings/city"];
  return (
    <>
      <div
        className={`sidebar ${props.isSidebarOpen ? "toggled" : ""}`}
        data-color={props.bgColor}
        data-active-color={props.activeColor}
      >
        <div className="logo">
          <button className="close_side" onClick={props.toggleSidebar}>✕</button>
          <Link to="/" className="simple-text logo-mini">
            <div className="logo-img">
              <img src="/images/logo-nav.png" alt="react-logo" />
              <img src="/images/logo-fill.png" alt="react-logo test" style={{ height:'auto' }}/>
            </div>
          </Link>
        </div>
        <div className="side_user_row">
          <div className="side_user_image">
            <img src="/images/default-person.png" alt="" />
          </div>
          <div className="side_user_title">
            <span>Welcome,</span>
            <UserName name={props.user?.user?.name} lastName={props.user?.user?.last_name} />
          </div>
        </div>
        <div className="sidebar-wrapper" ref={sidebar}>
          <Nav>
            {/* Main Section */}
            <li><p className="nav_head">General</p></li>

            {mainRoutes.map((prop, key) => {
              return (
                !prop?.subRoute && <li
                  className={
                    activeRoute(prop.path) + (prop.pro ? " active-pro" : "")
                  }
                  key={key}
                >
                  <NavLink to={prop.layout + prop.path} className="nav-NavLink" onClick={handleNavLinkClick}>
                    <div className="line_wrap">
                      <img src={prop.icon} alt="side" />
                      <img src={prop.iconActive} alt="side" />
                      <h2>{prop.title}</h2>
                    </div>
                  </NavLink>
                </li>
              );
            })}


            {ClientCollapse.some(IncludesUrl) && (
              <li>
                <div className="accordion border-0">
                  <div className="accordion-item bg-transparent border-0 text-white">
                    <h2 className="accordion-header" id="headingOne">
                      <button ref={clientRef} className="btn_slide accordion-button collapsed shadow-none bg-transparent text-white" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        <img src="/images/manage.png" alt="" />
                        Clients
                      </button>
                    </h2>

                    <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne">
                      <ul className="accordion-body py-0 bg_gray">
                        {ClientCollapse.map(
                          section =>
                            IncludesUrl(section) && (
                              <li key={section}>
                                <NavLink to={`/${section}`} className="nav-NavLink" onClick={handleNavLinkClick}>
                                  <div className="line_wrap">
                                    <img src={`/images/${section.includes('templates') ? 'admin' : 'meeting-place'}.png`} alt="side" />
                                    <img src={`/images/${section.includes('templates') ? 'admin-active' : 'meeting-place-active'}.png`} alt="side" />
                                    <h2>{section.includes('templates') ? 'Templates' : 'Accounts'}</h2>
                                  </div>
                                </NavLink>
                              </li>
                            )
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
            )}

            {/* Security Section */}
            {securityRoutes.map((prop, key) => {
              return (
                !prop?.subRoute && <li
                  className={
                    activeRoute(prop.path) + (prop.pro ? " active-pro" : "")
                  }
                  key={key}
                >
                  <NavLink to={prop.layout + prop.path} className="nav-NavLink" onClick={handleNavLinkClick}>
                    <div className="line_wrap">
                      <img src={prop.icon} alt="side" />
                      <img src={prop.iconActive} alt="side" />
                      <h2>{prop.title}</h2>
                    </div>
                  </NavLink>
                </li>
              );
            })}

            {
              props?.user?.role == 'admin'
              &&
              <li>
                <div className="accordion border-0">
                  <div className="accordion-item bg-transparent border-0 text-white">
                    <h2 className="accordion-header" id="headingpermission">
                      <button ref={permissionRef} className="btn_slide accordion-button collapsed shadow-none bg-transparent text-white" type="button" data-bs-toggle="collapse" data-bs-target="#collapsepermission" aria-expanded="false" aria-controls="collapsepermission">
                        <img src="/images/manage.png" alt="" />
                        Permissions
                      </button>
                    </h2>
                    <div id="collapsepermission" className="accordion-collapse collapse" aria-labelledby="headingpermission">
                      <ul className="accordion-body py-0 bg_gray">
                        <li>
                          <NavLink to="/permissions/groups" className="nav-NavLink" onClick={handleNavLinkClick}>
                            <div className="line_wrap">
                              <img src="/images/meeting-place.png" alt="side" />
                              <img src="/images/meeting-place-active.png" alt="side" />
                              <h2>User Groups</h2>
                            </div>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/permissions/sub-users" className="nav-NavLink" onClick={handleNavLinkClick}>
                            <div className="line_wrap">
                              <img src="/images/admin.png" alt="side" />
                              <img src="/images/admin-active.png" alt="side" />
                              <h2>Sub Users</h2>
                            </div>
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
            }

            {ToolsCollapse.some(IncludesUrl) && (
              <li>
                <div className="accordion border-0">
                  <div className="accordion-item bg-transparent border-0 text-white">
                    <h2 className="accordion-header" id="headingTwo">
                      <button ref={toolsRef} className="btn_slide accordion-button collapsed shadow-none bg-transparent text-white" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" >
                        <img src="/images/manage.png" alt="" />
                        Tools
                      </button>
                    </h2>
                    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo">
                      <ul className="accordion-body py-0 bg_gray">
                        {ToolsCollapse.map(
                          section =>
                            IncludesUrl(section) && (
                              <li key={section}>
                                <NavLink to={`/${section}`} className="nav-NavLink" onClick={handleNavLinkClick}>
                                  <div className="line_wrap">
                                    <img src={`/images/${section.includes('facility') ? 'meeting-place' : 'admin'}.png`} alt="side" />
                                    <img src={`/images/${section.includes('facility') ? 'meeting-place-active' : 'admin-active'}.png`} alt="side" />
                                    <h2>{section.includes('facility') ? 'Facilities' : 'Departments'}</h2>
                                  </div>
                                </NavLink>
                              </li>
                            )
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
            )}

            {SettingsCollapse.some(IncludesUrl) && (
              <li>
                <div className="accordion border-0">
                  <div className="accordion-item bg-transparent border-0 text-white">
                    <h2 className="accordion-header" id="headingThree">
                      <button ref={settingsRef} className="btn_slide accordion-button collapsed shadow-none bg-transparent text-white" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" >
                        <img src="/images/settings.png" alt="" />
                        Settings
                      </button>
                    </h2>
                    <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree">
                      <ul className="accordion-body py-0 bg_gray">
                        {SettingsCollapse.map(
                          section =>
                            IncludesUrl(section) && (
                              <li key={section}>
                                <NavLink to={`/${section}`} className="nav-NavLink" onClick={handleNavLinkClick}>
                                  <div className="line_wrap">
                                    <img src={`/images/${section.includes('language-tiers') ? 'language' : section.includes('language') ? 'language' : section.includes('state') ? 'state' : 'city' }.png`} alt="side"/>
                                    <img src={`/images/${section.includes('language-tiers') ? 'language-active' : section.includes('language') ? 'language-active' : section.includes('state') ? 'state-active' : 'city-active' }.png`} alt="side"
                                    />
                                    <h2>
                                      {section.includes('language-tiers') ? 'Language Tiers' : section.includes('language') ? 'Languages' : section.includes('state') ? 'States' : 'Cities'}
                                    </h2>
                                  </div>
                                </NavLink>
                              </li>
                            )
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
            )}

            <li>
              <a href="" onClick={handleLogout} className="nav-NavLink p-0" >
                <div className="line_wrap wrap_logout">
                  <img src='/images/LogOut.png' alt="side" />
                  <img src='/images/LogOut-fill.png' alt="side" />
                  <h2>Log Out</h2>
                </div>
              </a>
            </li>

          </Nav>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
